<form (ngSubmit)="onSubmit()">

  <div class="form-group mb-2">
    <label for="risks">{{'CONTROL-MODULE.SELECT_RISKS' | translate}}</label>
    @if (risks$) {
      <ntr-multiple-select #riskMulti [items]="risks$" [key]="'key'"
      [display]="'name'"></ntr-multiple-select>
    }
  </div>

  <div class="form-group mb-2">
    <label for="controlTypes">{{'CONTROL-MODULE.SELECT_CONTROL' | translate}}</label>
    <select [(ngModel)]="selectedControl" id="type" class="form-control" name="type"
      required>
      @for (value of controlTypes$; track value) {
        <option value={{value.key}}>
          {{value.name}}
        </option>
      }
    </select>
  </div>

  <div class="form-group mb-2">
    <label for="activity">{{'CONTROL-MODULE.ACTIVITE' | translate}}</label>
    <input type="text" class="form-control" id="activity"
      name="activity"
      [(ngModel)]="controlActivity">
    </div>

    <div class="form-group mb-2">
      <label for="executive">{{'CONTROL-MODULE.EXECUTIVE' | translate}}</label>
      <ng-select id="executive"
        name="executive"
        [items]="executives$"
        [clearable]="true"
        [(ngModel)]="controlexecutive">
      </ng-select>
    </div>

    <div class="form-group mb-2">
      <label for="dp">{{'CONTROL-MODULE.DERNIERE_PERIODE_VERIFIEE' | translate}}</label>
      <div class="input-group">
        <app-date-range-picker (valueChange) = "setDates($event)" [key]="'lastPeriod'"></app-date-range-picker>
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="sp">{{'CONTROL-MODULE.PERIODE_SOUMISE_A_VERIFICATION' | translate}}</label>
      <div class="input-group">
        <app-date-range-picker (valueChange) = "setDates($event)" [key]="'submittedPeriod'"></app-date-range-picker>
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="progSource">{{'CONTROL-MODULE.SOURCE_DE_PROGRAMMATION' | translate}}</label>
      <ng-select id="progSource"
        name="progSource"
        [items]="sources$"
        [clearable]="true"
        [(ngModel)]="controlProgSource">
      </ng-select>
    </div>

    @if (periodErrorKey) {
      <div class="alert alert-warning mb-2" role="alert">
        {{ periodErrorKey | translate }}
      </div>
    }

    <button type="submit" class="btn btn-primary"
    [disabled]="this.selectedControl===undefined || riskMulti['activeItems']===undefined || creating">{{'CONTROL-MODULE.OK' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="modalRef?.hide()">{{'CONTROL-MODULE.CANCEL' | translate}}</button>

  </form>

  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
  </ngx-spinner>
